import { render } from "./SegQuotation.vue?vue&type=template&id=01760760"
import script from "./SegQuotation.vue?vue&type=script&lang=js"
export * from "./SegQuotation.vue?vue&type=script&lang=js"
script.render = render

export default script